'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var ScrollLock_module = {};

exports.default = ScrollLock_module;
